import moment from 'moment';
import { v4 as uid } from 'uuid';
import { cloneDeep, isArray } from 'lodash-es';
import ChartBubble from '@intelligence/components/ChartBubble';
// import {  newMathFormat } from '@intelligence/utils/commonUtils';
import { getRealValueOfSerie, moveZero } from '@intelligence/utils/echartsUtils';
import EchartsBubble from '../components/EchartsBubble';
import { formatDateStr, getRoundIntegerNum, newMathFormatWrapper as newMathFormat } from '@gp/utils/common';
import { typeNameFormatter } from './index';
import { CONSTANT_KEYS } from '@gp/constants/const';
import {
  BASE_BAR_SERIES_OPTION,
  BASE_ECHART_OPTION,
  Y_AXIS_NAME_CURRENCY_OPTION,
  Y_AXIS_NAME_CURRENCY_GRID_TOP,
} from '@gp/constants/echarts';
import { FinancialsType, FinancialsDataMode } from '../enums';

import type { IRecord } from '@gp/types/global';

import '../components/EchartsBubble/index.scss';

const ACTUAL_ICON_DATAURL =
  'data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PScwIDAgMTAyNCAxMDI0JyB2ZXJzaW9uPScxLjEnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zycgd2lkdGg9JzE2JyBoZWlnaHQ9JzE2Jz48cGF0aCBkPSdNNTEyIDUxMm0tNTEyIDBhNTEyIDUxMiAwIDEgMCAxMDI0IDAgNTEyIDUxMiAwIDEgMC0xMDI0IDBaJyBmaWxsPScjYTNhNWIyJz48L3BhdGg+PC9zdmc+';

const FORECAST_ICON_DATAURL =
  'data:image/svg+xml;base64,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';

const TRENDS_KEYS = [CONSTANT_KEYS.ACTUAL, CONSTANT_KEYS.BUDGET];
const HEADCOUNT_KEYS = [CONSTANT_KEYS.ACTUAL, CONSTANT_KEYS.FORECAST];

const TYPE_INDEXS = {
  [CONSTANT_KEYS.ACTUAL]: 0,
  [CONSTANT_KEYS.BUDGET]: 1,
  [CONSTANT_KEYS.FORECAST]: 1,
};

const LEGEND_ICONS: Record<string, string> = {
  [CONSTANT_KEYS.ACTUAL]: ACTUAL_ICON_DATAURL,
  [CONSTANT_KEYS.BUDGET]: FORECAST_ICON_DATAURL,
  [CONSTANT_KEYS.FORECAST]: FORECAST_ICON_DATAURL,
};

const COLORS: Record<string, string> = {
  [CONSTANT_KEYS.ACTUAL]: '#2648a6',
  [CONSTANT_KEYS.BUDGET]: '#5086f3',
  [CONSTANT_KEYS.FORECAST]: '#5086f3',
};

const MILESTONE_COLORS: [string, string][] = [
  ['#3240A2', '#5B7FED'],
  ['#2C8663', '#5FD29F'],
  ['#2E3146', '#6F7692'],
  ['#A6842E', '#F3D658'],
  ['#4A32A2', '#8865EB'],
];

const getLegendIconWidthPrefix = (icon?: string): string => (!icon ? '' : `image://${icon}`);

const getBarColor = (financialsDataMode?: FinancialsDataMode, params?: any, name?: string): string => {
  if (financialsDataMode === FinancialsDataMode.ByMonth) return COLORS[name || ''];
  const { seriesName, dataIndex } = params || {};
  const seriesIndex = TYPE_INDEXS[seriesName];
  return MILESTONE_COLORS[dataIndex]?.[seriesIndex];
};

const transformData = (
  financialsDataMode?: FinancialsDataMode,
  list?: any[],
  valueFormatter?: (...args: any[]) => string | number,
): any[] => {
  if (!isArray(list) || !list.length) return [];
  const dataSource = cloneDeep(list);
  const result: any[] = [];
  const isByMilestone = financialsDataMode === FinancialsDataMode.ByMilestone;

  dataSource.forEach((item) => {
    item?.details?.forEach((detail: { name: string; value: unknown }) => {
      const { name, value } = detail || {};
      let existingObj = result.find((obj) => obj?.name === name);
      if (!existingObj) {
        existingObj = {
          ...BASE_BAR_SERIES_OPTION,
          name,
          barGap: '2%',
          data: [],
          itemStyle: {
            color: (params: any) => getBarColor(financialsDataMode, params, name),
          },
          label: {
            show: isByMilestone,
            position: 'top',
            formatter: (params: IRecord<any>): string => {
              const { value } = params || {};
              return valueFormatter?.(value) ?? value;
            },
          },
        };
        result.push(existingObj);
      }
      existingObj?.data?.push(value);
    });
  });

  return result;
};

const getLegendsByMonth = (list?: any[]): { name: string }[] => {
  if (!Array.isArray(list) || !list.length) return [];
  return list.map((item) => {
    const { name } = item || {};
    return {
      name,
      itemStyle: {
        color: COLORS[name],
      },
    };
  });
};

const getLegendsByMilestone = (list?: any[]): { name: string; icon: string | null }[] => {
  if (!Array.isArray(list) || !list.length) return [];
  return list.map((item) => {
    const { name } = item || {};
    return {
      name,
      icon: getLegendIconWidthPrefix(LEGEND_ICONS[name]),
    };
  });
};

const getLegends = (
  financialsDataMode?: FinancialsDataMode,
  list?: any[],
): { name: string; icon?: string | null }[] => {
  if (!financialsDataMode) return [];
  return financialsDataMode === FinancialsDataMode.ByMilestone ? getLegendsByMilestone(list) : getLegendsByMonth(list);
};

export const lineChartFormatting = (
  list: any[],
  key?: string | null,
  headerRightTitle?: string,
  financialsType?: FinancialsType,
  financialsDataMode?: FinancialsDataMode,
) => {
  if (!isArray(list)) return {};
  const isDevCost = financialsType === FinancialsType.DevCost;
  const isByMilestone = financialsDataMode === FinancialsDataMode.ByMilestone;
  const isHeadcountTrend = key === 'headcount_trend';
  const dataSource = cloneDeep(list);
  const legends = getLegends(financialsDataMode, dataSource?.[0]?.details);
  const xAxisData = dataSource?.map((task) => {
    const { date } = task || {};
    return isByMilestone ? date : formatDateStr(date, 'YYYY-MM');
  });
  const valueFormatter = isHeadcountTrend
    ? (value: any) => getRoundIntegerNum(value)
    : (value: any) => newMathFormat(value, true);

  return {
    grid: { ...BASE_ECHART_OPTION?.grid, top: isDevCost ? Y_AXIS_NAME_CURRENCY_GRID_TOP : 20 },
    tooltip: {
      ...BASE_ECHART_OPTION.tooltip,
      formatter: (params: any) => {
        const paramsTemp = [...(params || [])];
        const keys = isHeadcountTrend ? HEADCOUNT_KEYS : TRENDS_KEYS;

        paramsTemp.sort((a, b) => {
          const aKey = a?.seriesName;
          const bKey = b?.seriesName;
          return keys.indexOf(aKey) - keys.indexOf(bKey);
        });

        const list = paramsTemp.map((task) => {
          const { dataIndex, seriesName, seriesIndex, value } = task || {};
          return {
            name: typeNameFormatter(seriesName),
            num: valueFormatter(value),
            img: '',
            color: isByMilestone ? MILESTONE_COLORS?.[dataIndex]?.[seriesIndex] : COLORS[seriesName],
            color1: '',
          };
        });

        return EchartsBubble({
          data: {
            title: headerRightTitle,
            time: paramsTemp[0].name,
            list: list as any[],
          },
        });
      },
    },
    aria: {
      enabled: isByMilestone,
      decal: {
        show: true,
        decals: [
          {
            symbol: 'none',
          },
          {
            symbol: 'rect',
            color: 'rgba(255, 255, 255, 0.12)',
            dashArrayX: [4, 16],
            dashArrayY: [1, 0],
            rotation: 45,
          },
          // REMARK: 两个series，贴花这里非要配置3个对象才正常，少了最后这个对象，headcount的柱状图 就没有贴画了
          {
            symbol: 'rect',
            color: 'rgba(255, 255, 255, 0.12)',
            dashArrayX: [4, 16],
            dashArrayY: [1, 0],
            rotation: 45,
          },
        ],
      },
    },
    legend: {
      ...BASE_ECHART_OPTION.legend,
      data: legends,
      selectedMode: false,
      show: true,
      borderWidth: 0,
      left: 'center',
      formatter: typeNameFormatter,
    },
    xAxis: [
      {
        ...BASE_ECHART_OPTION.xAxis,
        type: 'category',
        data: xAxisData,
        axisTick: {
          // @ts-ignore
          ...BASE_ECHART_OPTION.xAxis?.axisTick,
          // 控制样式里的X轴字在中间距离Y轴还有点距离
          alignWithLabel: true,
        },
      },
    ],
    yAxis: [
      {
        // @ts-ignore
        ...BASE_ECHART_OPTION.yAxis?.[0],
        ...(isDevCost ? Y_AXIS_NAME_CURRENCY_OPTION : {}),
        type: 'value',
        axisLabel: {
          // @ts-ignore
          ...BASE_ECHART_OPTION.yAxis?.[0]?.axisLabel,
          formatter: valueFormatter,
        },
      },
    ],
    series: transformData(financialsDataMode, dataSource, valueFormatter),
  };
};

export const transformDataLineFlatMap = (list: any[]): any[] => {
  if (!isArray(list) || !list.length) return [];
  const result: any[] = [];

  list.forEach((item) => {
    const { date, details } = item || {};
    details?.forEach((detail: any) => {
      const { name, value } = detail || {};
      const valueFormatted = value === '' ? null : parseFloat(value);
      const existingObj = result.find((obj) => obj?.name === name);
      const metricTimelineData = {
        Date: date,
        metric: '',
        value: valueFormatted,
        growth_ratio: null,
      };

      if (existingObj) {
        existingObj.metric_time_line.push(metricTimelineData);
      } else {
        result.push({
          id: uid(),
          name,
          image_url: '',
          ipo_status: '',
          location_identifiers_country_code: '',
          metric_time_line: [metricTimelineData],
        });
      }
    });
  });

  return result;
};

export const getLineOrPieData = (tasks: any[], financialsDataMode: FinancialsDataMode): any[] => {
  if (!Array.isArray(tasks) || !tasks.length) return [];

  return tasks.map((task) => {
    const {
      id,
      name,
      image_url: imageUrl,
      ipo_status: ipoStatus,
      location_identifiers_country_code: locationIdentifiersCountryCode,
      metric_time_line: metricTimelines,
    } = task || {};

    const metricTimelinesFormatted = metricTimelines?.map((metricTimeline: any) => {
      const { data_source: dataSource, value, growth_ratio: growthRatio, Date: date } = metricTimeline || {};
      return {
        time: financialsDataMode === FinancialsDataMode.ByMilestone ? date : formatDateStr(date, 'YYYY-MM'),
        metric_value_list: [
          {
            data_source: dataSource ?? '',
            metric: 'total_revenue',
            value,
            growth_ratio: growthRatio ?? 0,
            growth_vaue: 0,
          },
        ],
      };
    });

    return {
      id,
      app_id: id,
      name,
      image_url: imageUrl,
      ipo_status: ipoStatus,
      location_identifiers_country_code: locationIdentifiersCountryCode,
      time_line: metricTimelinesFormatted || [],
    };
  });
};

export const lineFormatterTooltip = (params: any[], headerRightTitle: string, key = ''): string => {
  const paramsTemp = moveZero(params);
  const date = paramsTemp?.[0]?.axisValue;
  const dateStr = moment(date).format('YYYY-MM-DD');
  const sortedParamsTmp = [...paramsTemp].sort((a: any, b: any): number => {
    let aValue = getRealValueOfSerie(a?.value);
    let bValue = getRealValueOfSerie(b?.value);
    aValue = Number.parseFloat(aValue);
    bValue = Number.parseFloat(bValue);
    if (Number.isNaN(aValue) && Number.isNaN(bValue)) return 0;
    if (Number.isNaN(aValue)) return 1;
    if (Number.isNaN(bValue)) return -1;
    return bValue - aValue;
  });

  return ChartBubble({
    chartType: 'line',
    //   topChartsType: 'top_companies_revenue',
    //   imageType: 'mobile',
    useSerieNameFormatter: true,
    headerLeftTitle: dateStr,
    headerRightTitle,
    data: sortedParamsTmp,
    serieNameFormatter: typeNameFormatter,
    valueFormatter: key === 'headcount_trend' ? (params: any) => getRoundIntegerNum(params?.value?.[1]) : undefined,
  });
};

export const getLegendUniqBy = (list?: any[]): { name: string; icon: string | null }[] => {
  if (!Array.isArray(list) || !list.length) return [];
  return list.map((item) => {
    const { name } = item || {};
    return {
      name,
      icon: getLegendIconWidthPrefix(LEGEND_ICONS[name]) || null,
    };
  });
};
